import React, { Component } from 'react';
import noProfile from "../../assets/img/no-profile.png";
import { FiSunrise, FiSunset, FiSun, FiCalendar, FiWind, FiThermometer } from 'react-icons/fi';
import { GoLocation } from 'react-icons/go';
import { API_BASE_URL } from "../../constatns";
import moment from "moment";
import ReactGA from "react-ga";

class CatchDetail extends Component {

	constructor(props) {
		super(props);
		this.state = {data: null};

		fetch(`${API_BASE_URL}/catch/info?catchId=${this.props.match.params.id}`, {
			method: 'GET',
		}).then(res => res.text())
		.then(body => {
			let result = JSON.parse(body);
			console.log(result);
			this.setState({data: result});
		});
	}

	componentDidMount() {
	}

	render() {

		ReactGA.pageview(window.location.pathname + window.location.search);

		const length = this.state.data ? Math.floor(this.state.data.catch.length * 10)/10 : 0;
		const weight = this.state.data ? Math.floor(this.state.data.catch.weight/1000 * 100) /100 : 0;
		const catchDT = this.state.data ? moment(new Date(1 * (this.state.data.catch.catch_date))).format('YYYY-MM-DD HH:mm') : '';
		const sunRise = this.state.data && this.state.data.catch.weather && this.state.data.catch.weather.sys ? moment(new Date(1 * (this.state.data.catch.weather.sys.sunrise))).format('YYYY-MM-DD HH:mm') : '';
		const sunSet = this.state.data && this.state.data.catch.weather && this.state.data.catch.weather.sys ? moment(new Date(1 * (this.state.data.catch.weather.sys.sunset))).format('YYYY-MM-DD HH:mm') : '';

		return (
			<main className={'catch-page'}>
				{this.state.data ?
					<div>
						<div className="catch-detail-banner"></div>
						<div className="main-body section-gap offset-lg-4 col-lg-4" style={{paddingTop: '15px'}}>
							<div className="card" style={{padding: '10px'}}>
								<div className="card-header" style={{padding: '10px', marginLeft: '10px'}}>
									<div className={'row'}>
										<img className={'avata'} src={this.state.data.catch.angler.image_url ? this.state.data.catch.angler.image_url : noProfile}
												 style={{width: '60px', height: '60px', borderRadius: '50%'}}/>
										<div className="mb-0 mt-10"
												 style={{lineHeight: '22px', marginLeft: '8px'}}>{this.state.data.catch.angler.username}
												 <p style={{fontSize: '12px'}}>{this.state.data.catch.angler.country ? this.state.data.catch.angler.country.name : ''}</p>
										</div>
									</div>
								</div>
								<div className="card-body pd-10" >

									<div className="text-center">
										<img src={this.state.data.catch.img}
											 style={{maxHeight: '500px', maxWidth: '100%'}}/>
									</div>

									<div className={'text-right catch-meta'} >
										<span>{this.state.data.likesCnt}</span> LIKES
										<span className={'ml-10'}>{this.state.data.commentsCnt}</span> COMMENTS
									</div>
									<div className={'mt-10 mb-10'}><h3>{this.state.data.catch.fish.name_kr}</h3></div>
									<div className={'card m-0'} style={{padding: '5px'}}>
										<div className={'row justify-content-md-center'}>
											<div className={'col text-center'}>Length <span style={{fontWeight: 'bold'}}>{length}cm</span></div>
											<div className={'col-md-auto text-center'}>|</div>
											<div className={'col text-center'}> Weight <span style={{fontWeight: 'bold'}}>{weight}kg</span></div>
										</div>
									</div>
									<div className={'catch-meta'}><FiCalendar/> {catchDT}</div>
									<div className={'catch-meta'}><GoLocation/> {this.state.data.catch.catch_addr}</div>
									{this.state.data.catch.weather ?
										<div>
											{this.state.data.catch.weather.main.temp ?
												<div className={'catch-meta'}><FiThermometer/> {this.state.data.catch.weather.main.temp}</div>
												: ''}
											<div className={'catch-meta'}><FiWind/> {this.state.data.catch.weather.wind.speed}</div>
											<div className={'catch-meta'}><FiSun/> {this.state.data.catch.weather.weather[0].description}</div>
											<div className={'catch-meta'}><FiSunrise/> {' '+sunRise}</div>
											<div className={'catch-meta'}><FiSunset/> {' '+sunSet}</div>
										</div>
										: ''}
								</div>
							</div>
						</div>
					</div>
					: ''}
			</main>
		);
	}

}

export default CatchDetail;
